<template>
  <main class="detail-message">
    <div class="row">
      <div class="col-md-12 top-wrapper">
        <TopTemplate>
          <template v-slot:left-element>
            <h3>{{ $t("title.detailsDm") }}</h3>
          </template>

          <template v-slot:right-element>
            <div class="d-flex buttons-wrapper">
              <a
                @click="previewAction()"
                class="btn btn-outline-primary button"
                :disabled="loading"
              >
                <i class="arrow left"></i>
                {{ $t("button.retour") }}
              </a>
            </div>
          </template>
        </TopTemplate>
      </div>
    </div>
    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-if="!loading">
      <div class="row">
        <div class="col-md-9">
          <div class="general-info">
            <div class="row description-devoir">
              <div class="col-md-12">
                <div class="sub-title">
                    <h3>Contenu</h3>
                </div>
                <div class="distination sub-title">
                  <h1>{{ $t("tabDetail.destination") }}</h1>
                  <span><strong>{{ studentHomeWork }}</strong></span
                  ><a v-if="studentPerso" @click="scrollToTab()">{{
                    $t("common.voirTous")
                  }}</a>
                </div>
                <div class="envoyer-par">
                  <p><span>Expéditeur :</span> {{ createdFirstName }} {{ createdLastName }} </p>
                </div>
                <strong><p>{{ course }}</p></strong>
                <p
                  :class="{
                    'arabic-text': checkLanguag(reference.description),
                  }"
                  class="text-normal text-homwork context-editor"
                  v-html="reference.description"
                >
                </p>
                <span class="date"
                  >{{ $t("tabDetail.pourLe") }}
                  {{ formatDateFR(reference.due_date) }}</span
                >
                <hr />
                <h1>
                  <b>{{ $t("tabDetail.files") }}</b>
                </h1>
                <div class="row">
                  <span v-if="files.length === 0">
                    {{ $t("common.emptyFiles") }}
                  </span>
                  <span
                    v-else
                    class="col-md-5"
                    v-for="(file, index) in files"
                    :key="index"
                    ><i class="icon-file-04"></i>
                    <a :href="file.file_url" download> {{ file.file_name }}</a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="general-info">
            <h1>{{ $t("title.devoir") }}</h1>
            <div class="justify-content-center">
              <DonutChart
                v-if="displayGraph"
                :chart-data="chartDataMessage"
                :pluginsDevoir="pluginsDevoir"
                :cutoutDg="40"
                :heightDg="160"
                :position="'right'"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="search-date-wrapper search-filter-wrapper-v1 search-filter-wrapper borderNan"
      >
        <div class="col-md-12 search searchTeacher">
          <input
            v-model="params.q"
            type="text"
            placeholder="Recherche"
            name="search"
            @input="searshDM()"
          />
          <img
            src="../../assets/icons/search-icon.svg"
            class="icon-search"
            alt="search"
          />
        </div>
      </div>

      <div>
        <div v-if="loadingTab" class="card mt-4 text-center d-block pt-4 pb-4">
          <div class="spinner-border text-info" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div v-if="!loadingTab" class="general-info">
          <!-- <h1 class="justify-content-center">Liste des Parents</h1> -->
          <div v-if="listStudent.length === 0">
            <span>{{ $t("common.emptydestinataire") }}</span>
          </div>
          <div v-else>
            <div class="sub-title">
                    <h3>Suivi de la réception par destinataire</h3>
            </div>
            <div class="table message-list">
              <div class>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table__wrapper">
                      <table>
                        <thead>
                          <tr>
                            <th style="width: 30%">
                              {{ $t("tabDetail.parents") }}
                              <div
                                class="icon-wrapper"
                                @click="sortB('full_name_parent')"
                              >
                                <i
                                  class="ri-arrow-up-s-line"
                                  :class="[specTri('full_name_parent', true)]"
                                />
                                <i
                                  class="ri-arrow-down-s-line"
                                  :class="[specTri('full_name_parent', false)]"
                                />
                              </div>
                            </th>
                            <th style="width: 25%">
                              {{ $t('tabDetail.student') }}
                              <div class="icon-wrapper" @click="sortB('full_name_student')">
                                <i class="ri-arrow-up-s-line" :class="[specTri('full_name_student', true)]" />
                                <i class="ri-arrow-down-s-line" :class="[specTri('full_name_student', false)]" />
                              </div>
                            </th>
                            <th class="envle order-from">
                              {{ $t("tabDetail.status") }}
                              <div
                                class="icon-wrapper"
                                @click="sortB('date_seen')"
                              >
                                <i
                                  class="ri-arrow-up-s-line"
                                  :class="[specTri('date_seen', true)]"
                                />
                                <i
                                  class="ri-arrow-down-s-line"
                                  :class="[specTri('date_seen', false)]"
                                />
                              </div>
                            </th>
                            <th class="envle order-from">
                              {{ $t("tabDetail.date") }}
                              <div
                                class="icon-wrapper"
                                @click="sortB('date_seen')"
                              >
                                <i
                                  class="ri-arrow-up-s-line"
                                  :class="[specTri('date_seen', true)]"
                                />
                                <i
                                  class="ri-arrow-down-s-line"
                                  :class="[specTri('date_seen', false)]"
                                />
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="eleve in listStudent" :key="eleve.id" class="item_class">
                           <td><span v-if="eleve.full_name_parent">
                            <strong v-if="!eleve.full_name_student">{{ eleve.full_name_parent }}</strong>
                            <strong v-if="eleve.full_name_student"> {{ eleve.full_name_parent }}</strong>
                           </span><span v-else>__</span></td>
                           <td><span v-if="eleve.full_name_student"><strong v-if="!eleve.full_name_parent"> {{ eleve.full_name_student }}</strong>

                            <span v-if="eleve.full_name_parent">{{ eleve.full_name_student }}</span></span><span v-else>__</span></td>
                            <td v-if="eleve.date_seen === null">
                              <span class="noActive_status"> {{ $t('common.noLu') }}</span>
                            </td>
                            <td v-else>
                              <span class="active_status">
                                {{ $t("common.lu") }}</span
                              >
                            </td>
                            <td v-if="eleve.date_seen === null">
                              <span>__</span>
                            </td>
                            <td v-else>
                              <span> {{ formatDateFR(eleve.date_seen) }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div class="table__wrapper__pagination-wrapper">
                        <div class="pagination">
                          <pagination
                            v-if="last_page > 1"
                            :dataSet="pagination"
                            @goToPage="getDetailsStudent"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>




<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import HomeWorkService from "../../services/home-work.service";
import moment from "moment";
import pagination from "../../components/navigation/Pagination";
import "vue3-circle-progress/dist/circle-progress.css";
import DonutChart from "../../components/statistics/donutChart.vue";
export default {
  name: "DetailsDM",
  components: {
    TopTemplate,
    pagination,
    DonutChart,
  },
  data() {
    return {
      displayGraph: false,
      pagination: {},
      total: 0,
      last_page: null,
      referenceId: null,
      percentage: null,
      loading: false,
      loadingTab: false,
      listStudent: [],
      students: [],
      children: [],
      files: [],
      studentPerso: false,
      course: "",
      classe: "",
      createdFirstName : "",
      createdLastName:"",
      reference: {},
      pluginsDevoir: [{}],
      chartDataMessage: {
        labels: ["Lus      ", "Non lus"],
        datasets: [
          {
            backgroundColor: ["#34B9BB", "#F5A88C"],
            data: [],
            borderWidth: 2,
            borderRadius: 0,

            // angle: [50],
            // borderRadius: [{ innerStart: 50, outerStart: 50, innerEnd: 50, outerEnd: 50}],
            // spacing: -50,
          },
        ],
      },
      params: {
        q: "",
        limit: 10,
        page: 1,
        sort: "date_seen",
        order: false,
      },
      moment: null,
    };
  },
  computed: {
    studentHomeWork() {
     if(this.reference.homework_type === '1'){
      let names = '';
      this.students.forEach((element,index)=>{
        names+=index < 3 ? element.first_name+' '+element.last_name + ', ': ''
      })
      names = names.slice(0, -2);
      return this.classe+' - '+ names;
     }else {
      return this.classe
     }
  },
  },

  created() {
    this.moment = moment;
    this.referenceId = this.$route.params.id;
  },
  mounted() {
    this.getDetails();
  },
  methods: {
    scrollToTab() {
      window.scrollTo({
        top: 450,
        left: 0,
        behavior: "smooth",
      });
    },
    previewAction() {
      this.$store.dispatch("setSended", true);
      this.$router.go(-1);
    },
    checkLanguag(val) {
      const arabic = /[\u0600-\u06FF]/;
      return arabic.test(val); // displays true
    },
    formatDateFR(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    formatDateAR(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      this.getDetailsStudent();
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.getDetailsStudent();
    },
    scrollToTab() {
      window.scrollTo({
        top: 450,
        left: 0,
        behavior: "smooth",
      });
    },
    getDetails() {
      this.loading = true;
      HomeWorkService.get(this.referenceId)
        .then((response) => {
          this.reference = response.data.data;
          this.course = this.reference.course?.name;
          this.classe = this.reference.class?.name;
          this.files = this.reference.files;
          this.students = this.reference?.students_list;
          this.createdFirstName = this.reference.createdBy.first_name
          this.createdLastName = this.reference.createdBy.last_name
          this.getDetailsStudent()
        })
        .catch((error) => {
           if (error.response && error.response.status === 404) {
              this.$router.push('/error-404');
            }
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDetailsStudent(page = null) {
      this.loadingTab = true;
      this.params.page = !page ? this.params.page : page;
      HomeWorkService.getListStudents(this.referenceId, {
        params: {
          q: this.params.q,
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
        },
      })
        .then((response) => {
          this.listStudent = response.data.data;
          this.studentPerso =
            this.listStudent.length > 3 && this.reference.homework_type === "1";
          this.percentage =
            (this.reference.number_views / response.data.meta.total) * 100;
          let nbMsgLu = this.reference.number_views;
          let nbNotMsgLu =
            response.data.meta.total - this.reference.number_views;

          this.chartDataMessage.datasets[0].data = [nbMsgLu, nbNotMsgLu];
          this.displayGraph = true;
          this.pagination = this.makePagination(
            response.data.meta,
            response.data.links
          );
          this.total = response.data.meta.total;
          this.last_page = response.data.meta.last_page;
        })
        .catch((error) => {
           if (error.response && error.response.status === 404) {
              this.$router.push('/error-404');
            }
          console.error(error);
        })
        .finally(() => {
          this.loadingTab = false;
        });
    },
    makePagination(meta) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: meta.next_page_url,
        prev_page_url: meta.prev_page_url,
      };
    },
    searshDM: _.debounce(function () {
      if (
        this.params.q.toString().length > 1 ||
        !this.params.q.toString().length
      ) {
        this.params.page = 1;

        this.getDetailsStudent();
      }
    }, 200),
  },
};
</script>
<style scoped>
.sub-title h3{
  font-weight: 600;
    font-size: 14px;
    margin-bottom: 10px;

}
.sub-title  strong {
  font-size: 14px;
}
.detail-message .description-devoir .distination h1 {
  margin-bottom: 0;
}
.detail-message .description-devoir strong {
    height: auto;
    display: inherit;
}
.envoyer-par p span{
  color: #505050;
    font-size: 12px;
    text-transform: uppercase;
    padding: 5px;
    font-weight: initial;

}
.envoyer-par p {
margin: 0;
font-weight: 700;
    margin-right: 15px;
    font-size: 14px;
}
.detail-message .description-devoir .distination h1, .detail-message .description-devoir .distination .h1 {
    text-transform: initial;

}
.envoyer-par p span {
    text-transform: initial;

}
</style>
